// HtmlToPdf.tsx
import React from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Button } from 'antd';

interface Props {
  elementId: string;
  fileName?: string;
  downloadLabel?: string;
  buttonStyle?: React.CSSProperties;
  setLoading?:any,
  loading:boolean,
}

const HtmlToPdf: React.FC<Props> = ({
  elementId,
  fileName = 'document.pdf',
  downloadLabel = 'Download PDF',
  buttonStyle,
  setLoading,
  loading
  
}) => {


const handleDownloadPdf = async () => {
  const original = document.getElementById(elementId);
  if (!original) {
    console.warn(`Element with id "${elementId}" not found.`);
    return;
  }

  setLoading(true);

  try {
    // Clone the original element
    const clone = original.cloneNode(true) as HTMLElement;

    // Apply download-only styles to the clone
    clone.style.width = '794px';
     clone.style.height = 'auto';
    clone.style.fontSize = '18px';
    clone.style.lineHeight = '1.6';
    clone.style.padding = '40px';
    clone.style.background = '#fff';
    clone.style.color = '#000';
    clone.style.position = 'absolute';
    clone.style.top = '-9999px'; // Off-screen
    clone.style.left = '-9999px';
    clone.style.zIndex = '-1';

    // Append clone to body (but invisible)
    document.body.appendChild(clone);

    await new Promise(resolve => setTimeout(resolve, 100)); // Wait for render

    const canvas = await html2canvas(clone, {
      scale: 1.5,
      useCORS: true,
    });

    const pdf = new jsPDF('p', 'px', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgData = canvas.toDataURL('image/png');
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let position = 0;
    let heightLeft = imgHeight;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(fileName);
  } catch (err) {
    console.error('PDF generation failed:', err);
  } finally {
    // Remove the hidden clone from DOM
    const cloneEl = document.body.querySelector(`#${elementId}-clone`);
    if (cloneEl) cloneEl.remove();
    setLoading(false);
  }
};

  return (
    <div style={buttonStyle || { position: 'absolute', top: '23px', right: '110px' }}>
      <Button
        size="large"
        type="primary"
        className="property_card_btn"
        onClick={handleDownloadPdf}
        disabled={loading}
      >
        {loading ? "Downloading..." : downloadLabel}
      </Button>
    </div>
  );
};

export default HtmlToPdf;
